import { reload } from './state/reload.epic';
import { save } from './state/save.epic';

export const formEpics = [reload, save];
